<template>
	<span>
		<docs-hero></docs-hero>

		<v-tabs v-model="tab" >
			<v-tab v-for="item in tabs" :key="item.id" class="tab">
				{{ item.title }}
			</v-tab>
		</v-tabs>
		<v-tabs-items v-model="tab">
			<v-tab-item v-for="item in tabs" :key="item.id">
				<keep-alive>
					<component v-bind:is="item.component"></component>
				</keep-alive>
			</v-tab-item>
		</v-tabs-items>

		<page-footer></page-footer>
	</span>
</template>
<script>
	import DocsHero from "@/components/DocsHero";
	import DocsList from "@/components/DocsList";
	import PageFooter from "@/components/PageFooter";
	import PazarVersions from "@/components/PazarVersions";

	export default {
		name: "docs",
		data() {
			return {
				tab: null,
				tabs: [
					{ id: 1, title: "نسخه های پازارپلاس", component: "pazar-versions" },
					{ id: 2, title: "مستندات آموزشی", component: "docs-list" },
				],
			};
		},
		components: {
			DocsHero,
			DocsList,
			PazarVersions,
			PageFooter,
		},
		mounted: function () {
			if (this.$store.state.isAuthenticated && this.$store.state.docsList.length < 1) {
				this.$store.dispatch("getDocs");
			}
		},
	};
</script>
<style scoped>
	.tab {
		font-size: 16px !important;
		color: #125ec0 !important;
	}
</style>
